import {ReactNode, type HTMLAttributes, RefObject} from 'react';
import {Header} from '../layout';
import styles from './Tabs.module.scss';

export interface PaneProps extends HTMLAttributes<HTMLDivElement> {
  forwardRef?: RefObject<HTMLDivElement>;
  title: string;
  id?: string;
  children: ReactNode;
}

export function Pane({title, id, children, forwardRef, ...props}: PaneProps) {
  return (
    <div ref={forwardRef} className={styles.pane} id={id} {...props}>
      <Header>{title}</Header>
      {children}
    </div>
  );
}
